import { threeEngine } from 'Domain/Scene/Engine/ThreeEngine';

/**
 * Centre la caméra sur la scène
 */
export const targetCameraCenter = () => {
    threeEngine.targetCenter();
};

/**
 * Centre la caméra principale (alias pour targetCameraCenter)
 */
export const targetMainCameraCenter = () => {
    threeEngine.targetCenter();
};
